import { Injectable } from "@angular/core";
import { BasePatientsService } from "@apps/patient-core/src/app/services/abstracts/patients.service";

export const PATIENT_QUERY = () => `
  {
    patient {
      acquisition_source_id
      first_name
      id
      payment_plan_id
      portal_url_full
      prevent_appointment_booking
      registered_portal_user
      site_id
      preferred_phone_number
      age
      date_of_birth
      email_address
      last_name
      mobile_phone
      mobile_phone_country
      dentist {
        full_name
        id
      }
      dentist_recall_date
      hygienist_recall_date
      is_nhs
      nhs_country
    }
  }`;

@Injectable({
  providedIn: "root",
})
export class ConciergePatientsService extends BasePatientsService {
  protected _getPatientQuery(): string {
    return PATIENT_QUERY();
  }
}
